var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300 0H0V300H300V0ZM101.845 45H198.155C229.5 45 255 70.5002 255 101.845V198.157C255 229.5 229.5 255 198.157 255H101.845C70.5002 255 45 229.5 45 198.157V101.845C45 70.5002 70.5002 45 101.845 45ZM92.5797 150C92.5797 181.662 118.338 207.42 150 207.42C181.662 207.42 207.42 181.662 207.42 150C207.42 118.338 181.662 92.5797 150 92.5797C118.338 92.5797 92.5797 118.338 92.5797 150ZM191.826 89.1543C191.826 98.511 199.437 106.121 208.793 106.121C218.15 106.121 225.762 98.511 225.762 89.1543C225.762 79.7976 218.15 72.1857 208.793 72.1857C199.437 72.1857 191.826 79.7976 191.826 89.1543ZM150 104.891C125.128 104.891 104.891 125.126 104.891 150C104.891 174.872 125.128 195.109 150 195.109C174.874 195.109 195.109 174.872 195.109 150C195.109 125.126 174.874 104.891 150 104.891ZM204.137 89.1543C204.137 86.5876 206.227 84.4984 208.793 84.4984C211.362 84.4984 213.451 86.586 213.451 89.1543C213.451 91.7226 211.362 93.8102 208.793 93.8102C206.227 93.8102 204.137 91.721 204.137 89.1543Z",
    fill: "#0057b8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.a8a3a455b45db21c2751e7fe0d996f2d.svg";
export { ForwardRef as ReactComponent };